import React, { useState, useEffect } from "react";
import { JobService } from "../../../services/JobService";
import {
  Row,
  Card,
  CardBody,
  Input,
  FormGroup,
  Label,
  Button,
  Form,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Table,
  CardHeader,
  CardFooter,
} from "reactstrap";
import { Link, useParams } from "react-router-dom";

const SoftSkillSearch = (props) => {
 
  const { parentCallback,deletedList } = props;
  const [modalSoftSkill, setModalSoftSkill] = useState(false);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [languageshow, setlanguageShow] = useState(true);
  const [newList, setNewList] = useState([]);
  const [show, setShow] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchSoftSkill,setSearchSoftSkill]=useState([])
  useEffect(() => {
    getTotalSoftSkillsList();
  }, []);

  useEffect(()=>{
    setNewList(deletedList)
 },[deletedList])

  const onAddSkills = () => {
    setModalSoftSkill(true);
    
  };


  const getTotalSoftSkillsList = () => {
    JobService.getSoftSkillsService(sortOrder).then((response) => {
      var skillDetails = response.data;
      if (skillDetails != null) {
        const skills = skillDetails.skills;
        if (skills.length > 0) {
          setCategories(skills);
          setFilteredCategories(skills);
          setSearchSoftSkill(skills)
          for (let i = 0; i < skills.length; i++) {
            skills[i].skillLevel = "";
            skills[i].isChecked = false;
          }
          setCategories(skills);
          setFilteredCategories(skills);
          setSearchSoftSkill(skills)
        } else {
          setCategories([]);
          setFilteredCategories([]);
          setSearchSoftSkill(skills)
        }
      }
    });
  };

  const onAddSoftSkills = () => {
    parentCallback(newList);
    setModalSoftSkill(false);
    setFilteredCategories(searchSoftSkill);
  };
  const onCancleSoftSkillSearch=()=>{
    setModalSoftSkill(false);
    setFilteredCategories(searchSoftSkill)
  }
  const searchItems = (searchValue) => {
    setFilteredCategories(searchSoftSkill.filter(searchItem=>searchItem.name.toLowerCase().includes(searchValue.toLowerCase())))
  };

  const handleCheck = (event, Skills) => {
 
    if (event.target.checked) {
     if (newList.length>0){
        if ([...newList].includes(Skills)===false){
          setNewList([...newList,Skills])
        }
     }
     else{
      setNewList([...newList,Skills])
     }
        
    } 
    else if (event.target.checked===false) {
      
      setNewList(newList.filter(item=>item.id!==Skills.id))
    }
   
  };

  return (
    <>
      <Button
        className="btn-sm mt-1 t-button-skill-edu btn "
        type="submit"
        color="primary"
        outline
        onClick={onAddSkills}
      >
        + Soft skill
      </Button>
     
      <Modal
        scrollable={true}
        isOpen={modalSoftSkill}
        toggle={() => setModalSoftSkill(!modalSoftSkill)}
      >
        <ModalHeader className="mdl_header">
          <div>
            <strong>Select Soft Skills</strong>
          </div>
        </ModalHeader>
        <ModalBody className="labelSize">
          <div className="col-lg-12 p-0">
            <Input type="text" icon="search" placeholder="Search for skills" onChange={(e) => searchItems(e.target.value)}/>

            {languageshow &&
              filteredCategories.length > 0 &&
              filteredCategories.map((skill, index) => {
                return (
                  <div key={index}>
                    {/* {show.indexOf(skill) === -1 && ( */}
                      <div className="col-12">
                        <div className="row">
                          <div className="col-sm-6 mt-2">
                            <label>
                              <div className="terms">
                                <input
                                  id="softSkill"
                                  type="checkbox"
                                  className="input_skill"
                                  // checked={checkSkillStatus(skill.skillId)}
                                  onChange={(e) => handleCheck(e, skill)}
                                />
                                {skill.name}{" "}
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                    {/* )} */}
                  </div>
                );
              })}
            {filteredCategories.length == 0 && (
              <div className="t-nodata mt-4">
                <strong>Softskill not found</strong>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter className="p-4">
          <Button color="primary" size="sm" outline onClick={onAddSoftSkills}>
            Save
          </Button>{" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={onCancleSoftSkillSearch}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      
    </>
  );
};
export default SoftSkillSearch;